import React from 'react';
import type {
	ColumnDuration,
	TimelineDuration,
	TimelineWindow,
} from '../../../../../model/timeline';
import { getColumnPositions } from '../../../common/utils/columns.tsx';
import { getPosition } from './utils';
import ColumnsOverlay from './view';

type APIProps = {
	timelineWindow: TimelineWindow;
	timelineDuration: TimelineDuration;
	columnDurations: ColumnDuration[];
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ timelineWindow, timelineDuration, columnDurations }: APIProps) => (
	<ColumnsOverlay
		columnPositions={getColumnPositions(timelineDuration, columnDurations)}
		endPosition={getPosition(timelineWindow.before, timelineDuration)}
		startPosition={getPosition(timelineWindow.after, timelineDuration)}
	/>
);

export type { APIProps };
